import { render, staticRenderFns } from "./ProcessReservePlan.vue?vue&type=template&id=33228b6c&scoped=true"
import script from "./ProcessReservePlan.vue?vue&type=script&lang=js"
export * from "./ProcessReservePlan.vue?vue&type=script&lang=js"
import style0 from "./ProcessReservePlan.vue?vue&type=style&index=0&id=33228b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33228b6c",
  null
  
)

export default component.exports